import React from "react";
import "../styles/landing.css";
import services from "../information/Services";
import ServiceCard from "../components/ServiceCard";
import FlashlightSection from "../components/FlashLightElements/FlashLightSection";

const Services = () => {
  return (
    <FlashlightSection
      backgroundColor="#FFF6E8"
      curtainColor="#FFF6E8"
      cursor="auto"
      backgroundChildren={<div></div>}
      foregroundChildren={
        <div className="services-page-container">
          <h2 className="services-page-heading">
            NUESTROS SERVICIOS
          </h2>
          <div className="services-grid">
            {services.services &&
              services.services.map((service, index) => {
                return(
                  <ServiceCard
                    key={index}
                    title={service.title}
                    description={service.description}
                    link={`/services/${service.id}`}
                    alt={service.title}
                    icon={service.image}
                  />
                )
              })
            }
          </div>
        </div>
      }
    />
  );
};

export default Services;
